import { PropsWithChildren, SyntheticEvent, useCallback } from 'react';
import { closeSnackbar, SnackbarKey, SnackbarProvider } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';

function NotifyProvider(props: PropsWithChildren<unknown>) {
  const { children } = props;

  const onActionHandler = useCallback((key: SnackbarKey) => {
    function onClickHandler(e: SyntheticEvent) {
      e.stopPropagation();
      e.preventDefault();

      closeSnackbar(key);
    }

    return (
      <IconButton onClick={onClickHandler} size="small">
        <CloseIcon fontSize="small" />
      </IconButton>
    );
  }, []);

  return (
    <SnackbarProvider
      action={onActionHandler}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      maxSnack={4}
    >
      {children}
    </SnackbarProvider>
  );
}

export default NotifyProvider;
